import { toTitleCase } from '@utils/Format'
import { mergeDefined } from '@utils/object/mergeDefined'
import router from '@router'
import { GlobalBus } from '@services/bus'
import { RELOAD } from '@constants/Text'
import * as Sentry from '@sentry/vue'

const ADD_SEARCH_CLIENT = (state, payload) => {
  if (payload && payload.id) {
    let lista = state.clients
    lista = lista.filter((v) => {
      return v.id !== payload.id
    })
    state.clients = [payload, ...lista]
    window.localStorage.setItem(
      `698dc${state.user.id_interno}19d489c`,
      JSON.stringify(state.clients.slice(0, 10))
    )
  }
}

/**
 * Verificar se teve algum cliente salvo em cache que foi removido.
 * Atualizar dados dos clientes em cache.
 * @param {} state
 */
const CHECK_CLIENTS = (state) => {
  const id_clientes = (state.clientes || []).map((c, index) => {
    if (!c.id) {
      c.id = (c.id_cadastro_cliente || index) * -1
    }
    return c.id
  })

  state.clients = state.clients.filter((c) => {
    if (id_clientes.includes(c.id)) {
      const cliente = state.clientes
        ? state.clientes[id_clientes.indexOf(c.id)]
        : null
      if (cliente) {
        mergeDefined(c, cliente)
        if (state.client.id === cliente.id) {
          mergeDefined(state.client, cliente)
        }
      }
      return true
    }
    return false
  })

  window.localStorage.setItem(
    `698dc${state.user.id_interno}19d489c`,
    JSON.stringify(state.clients.slice(0, 10))
  )

  if (state.client && !id_clientes.includes(state.client.id)) {
    const anterior = state.client.id
    state.client = state.clients[0] || {}
    if (state.client.id !== anterior) {
      GlobalBus.$emit(RELOAD.CHANGE_CLIENT)
      GlobalBus.$emit(RELOAD.ASSETS)
    }
  }
}

const UPDATE_CLIENTS = (state, payload) => {
  if (!state.clients || !state.clients.length) {
    return
  }
  state.clients = state.clients.map((a) => {
    if (payload[a.id]) {
      a.id_cadastro_cliente = payload[a.id].id_cadastro_cliente || null
      a.name = payload[a.id].nome_cliente
      a.login = payload[a.id].email
      a.id_cliente_web = payload[a.id].id_cliente_web
    }
    return a
  })
  if (state.client && payload[state.client.id]) {
    state.client.id_cadastro_cliente =
      payload[state.client.id].id_cadastro_cliente || null
    state.client.name = payload[state.client.id].nome_cliente
    state.login = payload[state.client.id].email
    state.id_cliente_web = payload[state.client.id].id_cliente_web
  }
  window.localStorage.setItem(
    `698dc${state.user.id_interno}19d489c`,
    JSON.stringify(state.clients.slice(0, 10))
  )
}

const ADD_LIST_SEARCH_CLIENT = (state, payload) => {
  if (payload && payload.length > 0) {
    state.clients = [...new Set(payload, ...state.clients)]
    window.localStorage.setItem(
      `698dc${state.user.id_interno}19d489c`,
      JSON.stringify(state.clients.slice(0, 10))
    )
  }
}

const SET_CURRENT_CLIENT = (state, payload) => {
  if (payload) {
    state.client = payload
  }
}

const setSentry = (user) => {
  const escritorio = user.escritorio || {}
  Sentry.setUser({
    id: user.id_interno,
    username: user.nome,
    email: user.email || user.login || '',
    segment: user.tipo_usuario,
    escritorio: user.internal_user
      ? 'Interno'
      : (escritorio.id_interno || '') + ' - ' + (escritorio.nome || ''),
  })
  console.log('[Sentry] Definindo usuario', user)
}

// Monta o objeto `state.user` a partir do payload: permissões do tipo_usuario
// (fallback CLIENTE) + flags derivadas. As flags explícitas vêm DEPOIS do
// spread das permissões, então sobrescrevem qualquer flag homônima (ex.:
// IS_FINANCIAL deriva de `role`, não da permissão do tipo).
const buildUserState = (payload, perm) => ({
  ...payload,
  ...(perm[payload.tipo_usuario] || perm.CLIENTE),
  IS_INTERNAL: payload.internal_user,
  HAS_ACCESS_CONTRACTS: payload['internal_user:::aawz_contracts'],
  HAS_AREA: payload.revenue_areas && payload.revenue_areas.length > 0,
  HAS_SUBSIDIARIES: payload.subsidiaries && payload.subsidiaries.length > 0,
  IS_FINANCIAL: payload.role === 'financeiro',
  HAS_SPECIAL_ACCESS: payload.acesso_especifico, // parâmetro criado especificamente para a kona na modulo de Estrategia, na visão geral os filtros são ocultados para os usuários que possuem acesso_especifico === true
})

// Disponibiliza o usuário em `Vue.prototype.$user`. O `require` é lazy e o
// guard cobre ambientes onde o default export do Vue não existe (ex.: jest).
const exposeUserToVuePrototype = (user) => {
  const Vue = require('vue').default
  if (Vue) {
    Vue.prototype.$user = user
  }
}

const trySetSentry = (payload) => {
  try {
    setSentry(payload)
  } catch (err) {
    console.log('[Sentry] Não foi possivel definir usuario')
    console.error(err)
  }
}

const SET_CURRENT_USER = (state, payload) => {
  if (!payload) {
    state.user = null
    return
  }

  const perm = require('@constants/Permissoes').default
  payload.nome = toTitleCase(payload.nome || '')
  state.user = buildUserState(payload, perm)

  exposeUserToVuePrototype(state.user)
  console.info('Usuário: ', state.user)

  if (state.user.IS_CLIENTE) {
    state.client = {
      nome_cliente: payload.nome,
      id: payload.id_interno,
    }
  }
  if (state.user.parametrizar) {
    router.push({ name: 'parametrizacao' })
  }

  trySetSentry(payload)
}

const SET_CLIENTS = (state, payload) => {
  if (payload) {
    // {name, login, id}
    if (
      payload &&
      typeof payload === 'object' &&
      payload.length &&
      payload[0] &&
      payload[0].nome_cliente &&
      !payload[0].name
    ) {
      state.clientes = payload.map((c, index) => {
        if (!c.name && c.nome_cliente) {
          c.name = c.nome_cliente
        }
        if (!c.id) {
          c.id = (c.id_cadastro_cliente || index) * -1
        }
        return c
      })
    } else {
      state.clientes = payload || []
    }

    CHECK_CLIENTS(state)
    // const aux = state.clients.filter(c => {
    //   return state.clientes.some(cliente => {
    //     return cliente.id === c.id && cliente.id_cadastro_cliente === c.id_cadastro_cliente
    //   })
    // })

    // state.clients = aux;

    // window.localStorage.setItem(
    //   `698dc${state.user.id_interno}19d489c`,
    //   JSON.stringify(state.clients.slice(0, 10))
    // )
  }
}

const SET_EMAILS = (state, payload) => {
  if (payload) {
    payload = payload.map((v) => {
      v.email = v.email.toLowerCase()
      return v
    })
    state.emails = payload // [{ email: 'aawz@aawz.com.br', validated: true }, ...payload]
  }
}

const SET_DATAS = (state, payload) => {
  // payload: {id_cliente, data_atualizacao, data_cotizacao}
  if (payload && payload.id_cliente) {
    state.clientDatas = {
      data_atualizacao: {
        data: payload.data_atualizacao,
        id_cliente: payload.id_cliente,
      },
      data_cotizacao: {
        data: payload.data_cotizacao,
        id_cliente: payload.id_cliente,
      },
    }
  }
}

const SET_INCOMPLETES_ASSETS = (state, payload) => {
  state.has_incompletes_assets = payload
}

const SET_CLIENT_INFO = (state, payload) => {
  state.clientInfo = payload
}

const SET_AVATAR_URL = (state, payload) => {
  state.user.avatar_url = payload
}

export const SET_LOADING_USER = (state, payload) => {
  state.loading_user = payload
}

// Insere (ou atualiza) um cliente na lista global usada pelo filtro de
// clientes, sem refetch de toda a base (`getAllClients`/`SET_CLIENTS`).
// Usado no cadastro otimista: ao criar um cliente, ele já aparece no dropdown
// de filtro imediatamente. Em state.clientes o `id` equivale ao id_cliente_app
// (mesma chave que o filtro envia como `id_cliente_app`).
const UPSERT_CLIENTE = (state, payload) => {
  if (!payload || !payload.id) return
  const lista = Array.isArray(state.clientes) ? state.clientes : []
  const index = lista.findIndex((c) => c && c.id === payload.id)
  const cliente = {
    ...(index >= 0 ? lista[index] : {}),
    ...payload,
  }
  // SelectSearch usa `nome_cliente` como text e `name` como alias herdado de
  // SET_CLIENTS — mantém ambos sincronizados pra não exibir label vazio.
  if (cliente.nome_cliente && !cliente.name) {
    cliente.name = cliente.nome_cliente
  }
  if (index >= 0) {
    lista.splice(index, 1, cliente)
  } else {
    lista.push(cliente)
  }
  state.clientes = [...lista]
}

// Atualiza o nome do cliente na lista global (usada pelo filtro de clientes).
// Em state.clientes o `id` equivale ao id_cliente_app.
const UPDATE_CLIENTE_NOME = (state, payload) => {
  if (!payload || !payload.idClienteApp || !payload.nome) return
  const cliente = (state.clientes || []).find(
    (c) => c && c.id === payload.idClienteApp
  )
  if (!cliente) return
  cliente.nome_cliente = payload.nome
  cliente.name = payload.nome
  // `value` é o label cacheado que o SelectSearch grava (addValue a partir de
  // keyItem='nome_cliente'). Sem atualizar, o dropdown mostra o nome antigo.
  if (Object.prototype.hasOwnProperty.call(cliente, 'value')) {
    cliente.value = payload.nome
  }
  state.clientes = [...state.clientes]
}

export {
  ADD_SEARCH_CLIENT,
  UPSERT_CLIENTE,
  UPDATE_CLIENTE_NOME,
  ADD_LIST_SEARCH_CLIENT,
  SET_CURRENT_CLIENT,
  SET_CURRENT_USER,
  SET_CLIENTS,
  SET_DATAS,
  SET_EMAILS,
  SET_INCOMPLETES_ASSETS,
  SET_CLIENT_INFO,
  UPDATE_CLIENTS,
  SET_AVATAR_URL,
}
